export default function ImportDelivery() {
  return (
    <section className="relative py-20 overflow-hidden border-t border-white/10">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7e5f2a4d84b4c5015857896474d5cc26.jpg"
          alt="Entrega Steel Importações"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-gray-900/85 to-black/90"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Da Compra até Você
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Acompanhamos seu produto em cada etapa da jornada. Transparência total do início ao fim! 📦
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
            <div className="w-14 h-14 bg-indigo-900/50 rounded-xl flex items-center justify-center mb-4 border border-indigo-700/30">
              <i className="ri-shopping-cart-line text-3xl text-indigo-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Compra nos EUA</h3>
            <p className="text-gray-300 leading-relaxed">
              Compramos o produto que você escolheu com todo cuidado e atenção aos detalhes
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
            <div className="w-14 h-14 bg-indigo-900/50 rounded-xl flex items-center justify-center mb-4 border border-indigo-700/30">
              <i className="ri-plane-line text-3xl text-indigo-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Envio Internacional</h3>
            <p className="text-gray-300 leading-relaxed">
              Cuidamos de toda a logística e burocracia. Você só precisa aguardar!
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
            <div className="w-14 h-14 bg-indigo-900/50 rounded-xl flex items-center justify-center mb-4 border border-indigo-700/30">
              <i className="ri-map-pin-line text-3xl text-indigo-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Rastreamento</h3>
            <p className="text-gray-300 leading-relaxed">
              Durante o processo de importação vamos te atualizando e quando o produto estiver a caminho do seu endereço você receberá um código para poder acompanhar em tempo real
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
            <div className="w-14 h-14 bg-indigo-900/50 rounded-xl flex items-center justify-center mb-4 border border-indigo-700/30">
              <i className="ri-home-smile-line text-3xl text-indigo-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Entrega em Casa</h3>
            <p className="text-gray-300 leading-relaxed">
              Receba seu produto na porta de casa, com segurança e carinho! 🎉
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
